<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main posrule-modal">
      <div class="title-area" id="modal-moving">
        <h2>加工ルール</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area" v-if="!isSetRule">
        <ul>
          <li>
            <span>{{ spaceObjName + '（パーツ空間ID：' + form.pdOwnSpId + '）'}}</span>
          </li>
          <li v-for="process in processList" :key="process.pdId">
            <input type="radio" v-model.number="processId" :value="process.pdId" @change="$emit('changeFocusProcess', process.pdId)">
            <span class="label">{{'加工ID：' + process.pdId + '（' + process.pdOwnFaceType + '）'}}</span>
          </li>
        </ul>
      </div>
      <div class="main-area">
        <div class="data-area" v-if="isSetRule">
          <ul>
            <li>
              <span>{{'加工ID：' + selectedProcess.pdId + '（' + selectedProcess.pdOwnFaceType + '）'}}</span>
            </li>
            <li>
              <span class="label">加工ルールID</span>
              <div class="input">
                <input type="number" v-model.number="form.pdPosRuleId" :disabled=true>
              </div>
            </li>
            <li>
              <span class="label">座標X</span>
              <input type="number" v-model.number="form.pdX">
              <p class="error_message" v-if="validateErrorMessages.pdX">{{ validateErrorMessages['pdX'] }}</p>
            </li>
            <li>
              <span class="label">開始位置</span>
              <input type="number" v-model.number="form.pdPosStt">
              <p class="error_message" v-if="validateErrorMessages.pdPosStt">{{ validateErrorMessages['pdPosStt'] }}</p>
            </li>
            <li>
              <span class="label">終了位置</span>
              <input type="number" v-model.number="form.pdPosEnd">
              <p class="error_message" v-if="validateErrorMessages.pdPosEnd">{{ validateErrorMessages['pdPosEnd'] }}</p>
            </li>
            <li>
              <span class="label">加工間隔</span>
              <input type="number" v-model.number="form.pdPitch">
              <p class="error_message" v-if="validateErrorMessages.pdPitch">{{ validateErrorMessages['pdPitch'] }}</p>
            </li>
            <li v-if="ruleCount > 0">
              <span class="label">ルールへの値１</span>
              <input type="number" v-model.number="form.posRuleValue1">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue1">{{ validateErrorMessages['posRuleValue1'] }}</p>
            </li>
            <li v-if="ruleCount > 1">
              <span class="label">ルールへの値２</span>
              <input type="number" v-model.number="form.posRuleValue2">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue2">{{ validateErrorMessages['posRuleValue2'] }}</p>
            </li>
            <li v-if="ruleCount > 2">
              <span class="label">ルールへの値３</span>
              <input type="number" v-model.number="form.posRuleValue3">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue3">{{ validateErrorMessages['posRuleValue3'] }}</p>
            </li>
            <li v-if="ruleCount > 3">
              <span class="label">ルールへの値４</span>
              <input type="number" v-model.number="form.posRuleValue4">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue4">{{ validateErrorMessages['posRuleValue4'] }}</p>
            </li>
            <li v-if="ruleCount > 4">
              <span class="label">ルールへの値５</span>
              <input type="number" v-model.number="form.posRuleValue5">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue5">{{ validateErrorMessages['posRuleValue5'] }}</p>
            </li>
            <li v-if="ruleCount > 5">
              <span class="label">ルールへの値６</span>
              <input type="number" v-model.number="form.posRuleValue6">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue6">{{ validateErrorMessages['posRuleValue6'] }}</p>
            </li>
            <li v-if="ruleCount > 6">
              <span class="label">ルールへの値７</span>
              <input type="number" v-model.number="form.posRuleValue7">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue7">{{ validateErrorMessages['posRuleValue7'] }}</p>
            </li>
            <li v-if="ruleCount > 7">
              <span class="label">ルールへの値８</span>
              <input type="number" v-model.number="form.posRuleValue8">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue8">{{ validateErrorMessages['posRuleValue8'] }}</p>
            </li>
            <li v-if="ruleCount > 8">
              <span class="label">ルールへの値９</span>
              <input type="number" v-model.number="form.posRuleValue9">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue9">{{ validateErrorMessages['posRuleValue9'] }}</p>
            </li>
            <li v-if="ruleCount > 9">
              <span class="label">ルールへの値１０</span>
              <input type="number" v-model.number="form.posRuleValue10">
              <p class="error_message" v-if="validateErrorMessages.posRuleValue10">{{ validateErrorMessages['posRuleValue10'] }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" v-if="!isSetRule" @click="showEditModal(processId)">編集</button>
        <button type="button" class="main_btn" v-if="!isSetRule" @click="onCancel">閉じる</button>
        <button type="button" class="main_btn" v-if="isSetRule" @click="updateProcess">更新</button>
        <button type="button" class="main_btn" v-if="isSetRule" @click="onCancelEdit">戻る</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as AppUtil from '../../../utils/App'
import * as Api from '../../../utils/Api'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'PosRuleModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    focusedMenuSpace: Object
  },
  data () {
    return {
      modalShown: false,
      isSetRule: false,
      processId: '',
      /** 加工ルール情報 */
      form: {
        pdOwnSpId: '',
        pdId: '',
        pdPosRuleId: '',
        pdX: '',
        pdPosStt: '',
        pdPosEnd: '',
        pdPitch: '',
        posRuleValue1: '',
        posRuleValue2: '',
        posRuleValue3: '',
        posRuleValue4: '',
        posRuleValue5: '',
        posRuleValue6: '',
        posRuleValue7: '',
        posRuleValue8: '',
        posRuleValue9: '',
        posRuleValue10: ''
      },
      /** 設定ルール数 */
      ruleCount: 0,
      /** 選択空間オブジェクト名 */
      spaceObjName: '',
      /** 既存加工一覧 */
      processList: [],
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    selectedProcess: function () {
      if (this.processList === null) return null
      return this.processList.filter(process => process.pdId === this.processId)[0]
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** 加工モーダル表示 */
    showModal: function () {
      this.clearData()
      if (this.focusedMenuSpace !== null) {
        this.form.pdOwnSpId = this.focusedMenuSpace.id
      } else {
        this.form.pdOwnSpId = this.editCtrlSpaces[0].childrenSpaceModel[0].id
      }
      this.getProcessData()
      this.isSetRule = false
      this.modalShown = true
    },
    /** 編集モーダル表示 */
    showEditModal: function (id) {
      if (isNaN(this.processId) || this.processId === '') {
        this.errorMessage.text = '加工を選択してください'
        return
      }
      this.processId = id
      this.setProcessData()
      this.isSetRule = true
    },
    /** モーダルキャンセル */
    onCancel: function () {
      this.processId = ''
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** 編集キャンセル */
    onCancelEdit: function () {
      this.isSetRule = false
    },
    /** 既存加工ルール取得 */
    getProcessData: function () {
      axios.get(API_URL.PLANNING + '/process/' + this.form.pdOwnSpId)
        .then(response => {
          // 表示対象面の加工のみリストへ
          this.processList = response.data.data
          this.processId = this.processList[0].pdId
          this.$emit('changeFocusProcess', this.processId)
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
      this.spaceObjName = this.fileData.objectDataModelList.find(obj => {
        return obj.spaceId === this.form.pdOwnSpId
      }).objName
    },
    /** 加工ルール更新 */
    updateProcess: function () {
      if (!this.valid()) return
      let payload = this.form
      axios.post(API_URL.PLANNING + '/pos-rule/update', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          this.$emit('setResponseData', response)
          AppUtil.showModal({
            messages: ['更新しました。'],
            onOk: () => {
              this.isSetRule = false
            }
          })
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    /** 加工ルール情報の設定 */
    setProcessData: function () {
      if (this.selectedProcess) {
        this.form.pdId = this.selectedProcess.pdId
        this.form.pdPosRuleId = this.selectedProcess.pdPosRuleId
        this.form.pdX = this.selectedProcess.pdX
        this.form.pdPosStt = this.selectedProcess.pdPosStt
        this.form.pdPosEnd = this.selectedProcess.pdPosEnd
        this.form.pdPitch = this.selectedProcess.pdPitch
        this.form.posRuleValue1 = this.selectedProcess.posRuleValue1
        this.form.posRuleValue2 = this.selectedProcess.posRuleValue2
        this.form.posRuleValue3 = this.selectedProcess.posRuleValue3
        this.form.posRuleValue4 = this.selectedProcess.posRuleValue4
        this.form.posRuleValue5 = this.selectedProcess.posRuleValue5
        this.form.posRuleValue6 = this.selectedProcess.posRuleValue6
        this.form.posRuleValue7 = this.selectedProcess.posRuleValue7
        this.form.posRuleValue8 = this.selectedProcess.posRuleValue8
        this.form.posRuleValue9 = this.selectedProcess.posRuleValue9
        this.form.posRuleValue10 = this.selectedProcess.posRuleValue10
      }
      this.ruleCount = this.selectedProcess.posRuleModel.ruleDetailList.length
    },
    /** 入力チェック */
    valid: function () {
      let validList = []
      validList.push(this.validValue(true, this.form.pdX, 'pdX', '座標X'))
      validList.push(this.validValue(true, this.form.pdPosStt, 'pdPosStt', '開始位置'))
      validList.push(this.validValue(true, this.form.pdPosEnd, 'pdPosEnd', '終了位置'))
      validList.push(this.validValue(true, this.form.pdPitch, 'pdPitch', '最小加工間隔'))
      validList.push(this.validValue(this.ruleCount > 0, this.form.posRuleValue1, 'posRuleValue1', 'ルールへの値１'))
      validList.push(this.validValue(this.ruleCount > 1, this.form.posRuleValue2, 'posRuleValue2', 'ルールへの値２'))
      validList.push(this.validValue(this.ruleCount > 2, this.form.posRuleValue3, 'posRuleValue3', 'ルールへの値３'))
      validList.push(this.validValue(this.ruleCount > 3, this.form.posRuleValue4, 'posRuleValue4', 'ルールへの値４'))
      validList.push(this.validValue(this.ruleCount > 4, this.form.posRuleValue5, 'posRuleValue5', 'ルールへの値５'))
      validList.push(this.validValue(this.ruleCount > 5, this.form.posRuleValue6, 'posRuleValue6', 'ルールへの値６'))
      validList.push(this.validValue(this.ruleCount > 6, this.form.posRuleValue7, 'posRuleValue7', 'ルールへの値７'))
      validList.push(this.validValue(this.ruleCount > 7, this.form.posRuleValue8, 'posRuleValue8', 'ルールへの値８'))
      validList.push(this.validValue(this.ruleCount > 8, this.form.posRuleValue9, 'posRuleValue9', 'ルールへの値９'))
      validList.push(this.validValue(this.ruleCount > 9, this.form.posRuleValue10, 'posRuleValue10', 'ルールへの値１０'))
      let isVarid = true
      validList.forEach(e => {
        if (!e) isVarid = e
      })
      return isVarid
    },
    /** バリデーション */
    validValue: function (flg, value, key, errorMessage) {
      if (flg && (value === '' || value < 0)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'を入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    clearData: function () {
      this.form = {
        pdOwnSpId: '',
        pdId: '',
        pdPosRuleId: '',
        pdX: '',
        pdPosStt: '',
        pdPosEnd: '',
        pdPitch: '',
        posRuleValue1: '',
        posRuleValue2: '',
        posRuleValue3: '',
        posRuleValue4: '',
        posRuleValue5: '',
        posRuleValue6: '',
        posRuleValue7: '',
        posRuleValue8: '',
        posRuleValue9: '',
        posRuleValue10: ''
      }
      this.ruleCount = 0
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.posrule-modal{
  max-height: 100%;
  width: 450px;
}
.main-area {
  max-height: 680px;
  overflow-y: scroll;
}
.data-area{
  min-height: 150px;
  margin: 20px auto;
  li{
    margin-bottom: 20px;
    .label{
      min-width: 200px;
      display: inline-block;
      text-align: left;
    }
    .input{
      display: inline-block;
      text-align: left;
      label{
        min-width: 150px;
        text-align: left;
        padding: 0 10px;
        input[type="radio"]{
          margin: 0 3px;
        }
      }
    }
    input[type="number"]{
      width: 100px;
    }
    .input-size{
      display: inline-block;
      vertical-align: top;
      padding: 0 5px;
      .check{
        text-align: center;
      }
    }
  }
  .select-process {
    min-width: 200px;
  }
}
.errormessage-area{
  text-align: left;
  padding: 20px 140px;
}
.error_messages{
  margin-left: auto;
  margin-right: auto;
  max-width: 270px;
  min-width: 270px;
}
.error_message {
  min-width: 280px;
  display: inline-block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetPosRuleModal.vue